/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import url from "utils/url";
import environment from "modules/environment";

export default {
    send: function(events) {
        const promises = events.map(event => {
            const { category, action } = event.data;

            if (event.type === "page_view") {
                sendPixel("page_view", event.data);
            } else if (category === "cart" && action === "add_item") {
                return sendPixel("add_to_cart", event.data);
            } else if (
                category === "affiliate" &&
                (action === "lead" || action === "lead_sold_out")
            ) {
                return sendPixel("lead_generation", event.data);
            } else if (category === "email_capture" && action === "created") {
                return sendPixel("email_capture", event.data);
            } else if (category === "registration" && action === "signup") {
                return sendPixel("sign_up", event.data);
            }
        });

        return Promise.all(promises);
    }
};

function sendPixel(action, data) {
    ["https://pixelg.adswizz.com/one.png", "https://beacon.krxd.net/event.gif"].map(pixelURL => {
        const params = url.toQueryString({
            event_id: "KnPJL3lT",
            event_type: "cact",
            page_type: environment.get("pageType"),
            page_sub_type: environment.get("pageSubType"),
            user_id: environment.get("userId", ""),
            session_id: data.session_id,
            action
        });

        addPixel(`${pixelURL}?${params}`);
    });
}

function addPixel(url) {
    if (document.readyState === "complete") {
        const img = document.createElement("img");
        img.src = url;
    } else {
        window.addEventListener("load", () => addPixel(url), false);
    }
}

